import { render, staticRenderFns } from "./wave.md?vue&type=template&id=4bb24b15&"
import script from "./wave.md?vue&type=script&lang=js&"
export * from "./wave.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb24b15')) {
      api.createRecord('4bb24b15', component.options)
    } else {
      api.reload('4bb24b15', component.options)
    }
    module.hot.accept("./wave.md?vue&type=template&id=4bb24b15&", function () {
      api.rerender('4bb24b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/api/wave.md"
export default component.exports